import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import DefaultLayout from './layouts/default';
import './assets/styles/reset.scss';
import './assets/styles/core.scss';
import OnLoadClass from './components/OnLoadClass/OnLoadClass';
import ActionOnView from './components/ActionOnView/ActionOnView';
import ScrollToTopFunc from './components/ScrollToTopFunc/ScrollToTopFunc';
import MainRoute from './routes/main-route';
import Cookiebot from 'react-cookiebot';

// Extend TypeScript window object
declare global {
  interface Window {
    Cookiebot?: {
      renew: () => void;
    };
  }
}

const App: React.FC = () => {
  useEffect(() => {
    const checkCookiebot = setInterval(() => {
      if (window.Cookiebot?.renew) {
        window.Cookiebot.renew();
        clearInterval(checkCookiebot); // Stop checking once found
      }
    }, 500); // Check every 500ms

    setTimeout(() => clearInterval(checkCookiebot), 5000); // Stop checking after 5s
  }, []);

  return (
    <>
      {/* <Cookiebot domainGroupId="90fff4f5-63ea-43f8-841e-29ba4ec95cc2" /> */}
      <Cookiebot domainGroupId="337b5b59-3942-49ef-8e12-c6289036963b" />
      <Router>
        <ScrollToTopFunc />
        <OnLoadClass />
        <ActionOnView />
        <DefaultLayout>
          <MainRoute />
        </DefaultLayout>
      </Router>
    </>
  );
};

export default App;
